var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-App_Bottom-Nav",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "More-1",
    transform: "translate(-20.000000, -310.000000)",
    fill: "#ffffff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_page",
    transform: "translate(16.000000, 308.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0003,4.0001 L6.0003,4.0001 L6.0003,20.0001 L18.0003,20.0001 L18.0003,9.0001 L13.0003,9.0001 L13.0003,4.0001 Z M15.0003,5.41431356 L15.0003,7.0001 L16.5860864,7.0001 L15.0003,5.41431356 Z M4.0003,22.0001 L4.0003,2.0001 L14.4145136,2.0001 L20.0003,7.58588644 L20.0003,22.0001 L4.0003,22.0001 Z M9.0941,11.0001 L9.0941,13.0001 L7.0941,13.0001 L7.0941,11.0001 L9.0941,11.0001 Z M9.0941,15.0001 L9.0941,17.0001 L7.0941,17.0001 L7.0941,15.0001 L9.0941,15.0001 Z M17.0003,11.0001 L17.0003,13.0001 L11.0003,13.0001 L11.0003,11.0001 L17.0003,11.0001 Z M17.0003,15.0001 L17.0003,17.0001 L11.0003,17.0001 L11.0003,15.0001 L17.0003,15.0001 Z",
    id: "shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDocs);
export default __webpack_public_path__ + "static/media/ico-docs.6d7157278e497199f48c9115d35718ce.svg";
export { ForwardRef as ReactComponent };